<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Department Activity</v-card-title>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete :disabled="disable_dep" v-model="searchdep_id" :items="dep_list" item-text="department_name"
            item-value="id" label="Department" outlined dense clearable @click:clear="
              $nextTick(() => {
                searchdep_id = 0;
                onSearchPagination();
              })
              " @change="onSearchPagination">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="searchEmp" :items="emp_list" label="Employee" item-text="name" item-value="id"
            outlined dense @change="onSearchPagination" multiple>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="searchChargeJob" :items="jobTitle_list" label="Assignment / Case" item-text="name"
            item-value="name" outlined dense @change="onSearchPagination" clearable @click:clear="
              $nextTick(() => {
                searchChargeJob = '';
              })
              "></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete v-model="searchCharge" :items="charge_list" label="Charge Type" item-text="name"
            item-value="value" outlined dense @change="onSearchPagination" clearable @click:clear="
              $nextTick(() => {
                searchCharge = '';
              })
              "></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddatefromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false" @change="onSearchPagination"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false" @change="onSearchPagination"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="   595959"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="authorize_edit"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }"
              @click="openeditItem(item.id)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="authorize_del"
              class="ml-5"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }"
              @click="deleteItem(item.id)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="totalItems"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon v-if="authorize_edit" :style="{
                backgroundColor: '#E1F5FE',
                color: '#254E58',
              }" @click="openeditItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon v-if="authorize_del" class="ml-5" :style="{
                backgroundColor: '#FFEBEE',
                color: '#9E3B1B',
              }" @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";

export default {
  name: "advance-list",
  data(vm) {
    const toBKKDateString = (date) => {
      // บวก 7 ชั่วโมงจาก UTC
      const bkkDate = new Date(date.getTime() + 7 * 60 * 60 * 1000);
      // คืนค่าเป็น yyyy-mm-dd
      return bkkDate.toISOString().slice(0, 10);
    };

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      dep_list: [],
      datefrom: toBKKDateString(firstDay),
      dateto: toBKKDateString(today),
      search_status: "",
      searchdep_id: 0,
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],

      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      // mDataArray: [
      //   {
      //     no: 1,
      //     date: "1/11/2022",
      //     name: "testname",
      //     customer: "ABS co Ltd",
      //     amount: "10,000",
      //     status: "Unapproved",
      //   },
      //   {
      //     no: 2,
      //     date: "2/11/2022",
      //     name: "testname2",
      //     customer: "ABS co Ltd",
      //     amount: "3,000",
      //     status: "Approved",
      //   },
      // ],
      headers: [
        {
          text: "Department Name",
          value: "dep_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
        },
        {
          text: "Name",
          value: "name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "10%",
          width: "120px",
        },
        {
          text: " Assignment/Case ",
          value: "job_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "140px",
        },
        {
          text: "Client",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
        },
        {
          text: "Start Date",
          value: "checkindate_show",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
          align: "center",
        },

        {
          text: "End Date",
          value: "checkoutdate_show",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "150px",
          align: "center",
        },
        {
          text: "Hour",
          value: "durationShow",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "140px",
          align: "end",
          sortable: false,
        },
        {
          text: "Charge Type",
          value: "chargetype",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "120px",
          align: "center",
        },
        // {
        //   text: "Prospect",
        //   value: "prospect",
        //   class: "bg-colorth tabletextwhite",
        //   divider: true,
        //   width: "100px",
        // },
        {
          text: "Detail",
          value: "detail",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "200px",
        },
        // {
        //     text: "",
        //     value: "actions",
        //     class: "bg-colorth tabletextwhite",
        //     divider: true,
        //     width: "110px",
        //     align: "center"
        // },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      jobTitle_list_search: [],
      searchCharge: "",
      searchChargeJob: "",
      searchEmp: [],
      emp_list: [],
      emp_list_search: [],
      disable_dep: false,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  beforeUpdate() { },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();



    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);



    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;


    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.loadDepData();
    await this.loadEmpData();
    await this.loadJobData();

    if (localStorage.getItem(server.ROLE) == "ADMIN") {
      this.searchdep_id = 0;
      this.disable_dep = false;
    } else {
      this.searchdep_id = Number(localStorage.getItem(server.DEPARTMENT_ID));
      this.disable_dep = true;
      await this.changeDep();
    }

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    this.$hideLoader();
    // await this.loaddata();
  },
  methods: {
    // 3. loaddataPagination
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let search_emp =
        this.searchEmp.length > 0 ? this.searchEmp.join(",") : null;
      console.log("search_emp: " + search_emp)
      const companyId = Number(localStorage.getItem(server.COMPANYID)) || 1;
      console.log("companyId:", companyId, "raw:", localStorage.getItem(server.COMPANYID));
      console.log("params:", {
        pageNumber,
        itemsPerPage: this.itemsPerPage,
        datefrom: this.datefrom,
        dateto: this.dateto,
        userId: search_emp,
        searchdep_id: this.searchdep_id,
        jobTitleId: this.searchChargeJob,
        searchEmp: this.searchEmp,
        searchChargeJob: this.searchChargeJob,
        searchCharge: this.searchCharge,
      });

      try {
        const result = await api.getAllActivityByDatePagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          this.datefrom,
          this.dateto,
          search_emp,
          this.searchdep_id,
          null,
          this.searchChargeJob,
          null,
          this.searchCharge,
          companyId,
        );

        console.log("result:", result);
        console.log("result.data:", result?.data);
        console.log("result.data.data:", result?.data?.data);
        console.log("pagination:", result?.data?.pagination);

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          console.log("item.duration:", item.duration, typeof item.duration);
          const totalMinutes = Math.round(Number(item.duration));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      const companyId = Number(localStorage.getItem(server.COMPANYID)) || 1;
      let sortDesc = options.sortDesc[0] ? "DESC" : "ASC";
      let search_emp =
        this.searchEmp.length > 0 ? this.searchEmp.join(",") : null;

      try {
        const result = await api.getAllActivityByDatePagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0] || "id",
          sortDesc,
          this.datefrom,
          this.dateto,
          search_emp,
          this.searchdep_id,
          null, // customerId
          this.searchChargeJob,
          null, // caseType
          this.searchCharge,
          companyId,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          const totalMinutes = Math.round(Number(item.duration));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        //console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. loadDataByPage
    // async loadDataByPage(pageNumber) {
    //   this.tableLoading = true;
    //   let tmp = [];
    //   this.dataAll2 = [];
    //   this.mDataArray2 = [];

    //   const companyId = Number(localStorage.getItem(server.COMPANYID)) || 1;

    //   try {
    //     const result = await api.getAllActivityByDatePagination(
    //       pageNumber,
    //       this.itemsPerPage,
    //       "id",
    //       "ASC",
    //       this.datefrom,
    //       this.dateto,
    //       localStorage.getItem(server.USER_ID),
    //       this.searchdep_id,
    //       null, // customerId
    //       this.searchEmp,
    //       this.searchChargeJob,
    //       null, // caseType
    //       this.searchCharge,
    //       companyId,
    //     );

    //     tmp = result.data.data;
    //     this.dataAll2 = tmp;
    //     this.mDataArray2 = tmp;

    //     this.mDataArray2.forEach((item) => {
    //       const totalMinutes = Math.round(Number(item.duration));
    //       const hours = Math.floor(totalMinutes / 60);
    //       const minutes = totalMinutes % 60;

    //       let durationText = "";
    //       if (hours > 0 && minutes > 0) {
    //         durationText = `${hours} ชั่วโมง ${minutes} นาที`;
    //       } else if (hours > 0) {
    //         durationText = `${hours} ชั่วโมง`;
    //       } else {
    //         durationText = `${minutes} นาที`;
    //       }
    //       item.durationShow = durationText;
    //     });

    //     this.totalItems = result.data.pagination.totalRecords;
    //     this.page = result.data.pagination.currentPage;
    //     this.itemsPerPage = result.data.pagination.recordsPerPage;
    //     this.pageCount = result.data.pagination.totalPages;
    //   } catch (error) {
    //     //console.error("Error loading page data:", error);
    //   } finally {
    //     this.tableLoading = false;
    //   }

    // },

    // 6. onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      const companyId = Number(localStorage.getItem(server.COMPANYID)) || 1;
      let search_emp =
        this.searchEmp.length > 0 ? this.searchEmp.join(",") : null;

      try {
        const result = await api.getAllActivityByDatePagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          this.datefrom,
          this.dateto,
          search_emp,
          this.searchdep_id,
          null, // customerId
          this.searchChargeJob,
          null, // caseType
          this.searchCharge,
          companyId,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.mDataArray2.forEach((item) => {
          const totalMinutes = Math.round(Number(item.duration));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          let durationText = "";
          if (hours > 0 && minutes > 0) {
            durationText = `${hours} ชั่วโมง ${minutes} นาที`;
          } else if (hours > 0) {
            durationText = `${hours} ชั่วโมง`;
          } else {
            durationText = `${minutes} นาที`;
          }
          item.durationShow = durationText;
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        //console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async loadDepData() {
      const resultDepList = await api.getNewAllDepartment_By_CompanyID(
        Number(localStorage.getItem(server.COMPANYID)),
      );
      this.dep_list = resultDepList.data;
    },
    async loadEmpData() {
      const resultList = await api.getAccountsByCompanyCIO(
        Number(localStorage.getItem(server.COMPANYID)),
      );
      this.emp_list = resultList.data;
      this.emp_list_search = resultList.data;
    },
    async loadJobData() {
      const res_joblist = await api.getAllJobtitleByDepartment(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
            department: localStorage.getItem(server.DEPARTMENT_ID),
          },
        }
      );
      this.jobTitle_list = res_joblist.data;
      this.jobTitle_list_search = res_joblist.data;
    },

    async loaddata() {
      this.$showLoader();
      var dataitem = {
        dateform: this.datefrom,
        dateto: this.dateto,
      };

      const resData = await api.getAllActivityByDate({ params: dataitem });
      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.mDataArray.forEach((item) => {
        var decimalHour = Number(item.duration);
        const hours = Math.floor(decimalHour); // ได้ 3 ชั่วโมง
        const minutes = Math.round((decimalHour - hours) * 60);

        let durationText = "";
        if (hours > 0 && minutes > 0) {
          durationText = `${hours} ชั่วโมง ${minutes} นาที`;
        } else if (hours > 0) {
          durationText = `${hours} ชั่วโมง`;
        } else {
          durationText = `${minutes} นาที`;
        }
        item.durationShow = durationText;
      });
      this.$hideLoader();
    },

    async changeDep() {
      if (this.searchdep_id != 0) {
        this.searchEmp = 0;
        this.searchChargeJob = "";
        this.emp_list = this.emp_list_search.filter(
          (emp) => emp.department_i_d === this.searchdep_id,
        );
        this.jobTitle_list = this.jobTitle_list_search.filter(
          (job) => job.department_id === this.searchdep_id,
        );

        this.findChaege();
      } else {
        this.searchEmp = 0;
        this.searchChargeJob = "";
        this.emp_list = this.emp_list_search;
        this.jobTitle_list = this.jobTitle_list_search;
      }
    },
    editItem() { },
    changelange: function (newVal, oldVal) { },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },

    findChaege() {
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.searchdep_id && Number(this.searchdep_id) !== 0) {
          if (Number(item.departmentId) !== this.searchdep_id) return false;
        }

        if (this.searchChargeJob && this.searchChargeJob !== "") {
          if (item.job_name !== this.searchChargeJob) return false;
        }

        if (this.searchCharge && this.searchCharge !== "") {
          if (item.chargeType !== this.searchCharge) return false;
        }
        if (this.searchEmp && this.searchEmp.length > 0) {
          if (!this.searchEmp.includes(Number(item.userId))) return false;
        }

        return true;
      });

    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      this.authorize = res_get.data;
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}

.text-left {
  color: aliceblue;
}

.widthsizesearch {
  width: 70%;
}

.theme--light.v-card {
  border-color: white;
}
</style>
